// extracted by mini-css-extract-plugin
export default {"container":"RiuNJc_dW5SBYoBIEYr9","form":"RIPTK4DqoY8Yt5UzD69C","eraseButton":"F5wYxMC6Ja59l59_A94g","searchButton":"UQPV7E5BhjF15koHCaki","searchInput":"TfJM8lDMjExrO28bW189"};